import React, { useState } from "react";
import "./DonationDetails.css";
import DonationSectionAnother from './DonationSectionAnother';

const donationData = [

  {
    title: "ILM FOUNDATION EDUCATION & WELFARE WAKF",
    accountNo: "07131450000939",
    ifsc: "HDFC0000713",
    bank: "HDFC Bank",
    branchCode: "713",
    branch: "IHM Branch, Chhatrapati Sambhajinagar (Aurangabad)",
    type: "Current Account",
    micr: "431240004",
    color: "#3498db",
    icon: "📘"
  },
];

const DonationDetailsAnother = () => {
  const [copiedField, setCopiedField] = useState(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const copyToClipboard = (text, fieldName, fieldLabel) => {
    navigator.clipboard.writeText(text);
    setCopiedField(fieldName);
    setToastMessage(`"${fieldLabel}" copied to clipboard!`);
    setToastVisible(true);
    
    setTimeout(() => {
      setCopiedField(null);
    }, 2000);
    
    setTimeout(() => {
      setToastVisible(false);
    }, 3000);
  };

  return (
    <>
    <DonationSectionAnother />
      <div className="donation-containerr">
        {/* Toast Notification */}
        {toastVisible && (
          <div className="copy-toast">
            <div className="toast-content">
              <span className="toast-icon">✓</span>
              <span className="toast-message">{toastMessage}</span>
            </div>
          </div>
        )}

        <div className="donation-header">
          <h2 className="donation-title">Support Our Cause</h2>
          <p className="donation-subtitle">Your donation makes a difference</p>
          <div className="header-decoration"></div>
        </div>

        <div className="donation-grid">
          {donationData.map((item, idx) => (
            <div key={idx} className="donation-cardd" style={{ "--accent-color": item.color }}>
              <div className="card-header">
                <span className="bank-icon">{item.icon}</span>
                <h3>{item.title}</h3>
              </div>
              
              <div className="account-details">
                <div className="detail-row">
                  <span className="detail-label">Account No:</span>
                  <div className="detail-value">
                    <span>{item.accountNo}</span>
                    <button 
                      className={`copy-btn ${copiedField === `account-${idx}` ? 'copied' : ''}`}
                      onClick={() => copyToClipboard(item.accountNo, `account-${idx}`, "Account Number")}
                      aria-label="Copy account number"
                    >
                      {copiedField === `account-${idx}` ? '✓ Copied' : '📋 Copy'}
                    </button>
                  </div>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">IFSC Code:</span>
                  <div className="detail-value">
                    <span>{item.ifsc}</span>
                    <button 
                      className={`copy-btn ${copiedField === `ifsc-${idx}` ? 'copied' : ''}`}
                      onClick={() => copyToClipboard(item.ifsc, `ifsc-${idx}`, "IFSC Code")}
                      aria-label="Copy IFSC code"
                    >
                      {copiedField === `ifsc-${idx}` ? '✓ Copied' : '📋 Copy'}
                    </button>
                  </div>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Bank Name:</span>
                  <span className="detail-value">{item.bank}</span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Branch:</span>
                  <span className="detail-value">{item.branch}</span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Account Type:</span>
                  <span className="detail-value">{item.type}</span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">MICR Code:</span>
                  <div className="detail-value">
                    <span>{item.micr}</span>
                    <button 
                      className={`copy-btn ${copiedField === `micr-${idx}` ? 'copied' : ''}`}
                      onClick={() => copyToClipboard(item.micr, `micr-${idx}`, "MICR Code")}
                      aria-label="Copy MICR code"
                    >
                      {copiedField === `micr-${idx}` ? '✓ Copied' : '📋 Copy'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="donation-actions">
          <button className="back-btn" onClick={() => window.history.back()}>
            <span className="btn-icon">←</span> BACK
          </button>
        </div>

        <div className="donation-footer">
          <p>All donations are tax exempted under 80G of Income Tax Act</p>
        </div>
      </div>
    </>
  );
};

export default DonationDetailsAnother;